import { render, staticRenderFns } from "./vueTour.vue?vue&type=template&id=256c0584&scoped=true"
import script from "./vueTour.vue?vue&type=script&lang=js"
export * from "./vueTour.vue?vue&type=script&lang=js"
import style0 from "./vueTour.vue?vue&type=style&index=0&id=256c0584&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "256c0584",
  null
  
)

export default component.exports